module.exports = __webpack_public_path__ + "img/19_10.b01438d1.png";